import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import { sendUserTimings } from "./send";
var initStartTime = new Date().getTime();
var markList = [];

var findMark = function findMark(name) {
  //reverse会修改原数组
  return markList.concat([]).reverse().find(function (item) {
    return item.name === "".concat(name);
  }); // 转string
};

var getCurrentTime = function getCurrentTime() {
  var _window, _window$performance, _window2, _window2$performance;

  if ((_window = window) !== null && _window !== void 0 && (_window$performance = _window.performance) !== null && _window$performance !== void 0 && _window$performance.now) {
    return performance.now();
  } else if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$performance = _window2.performance) !== null && _window2$performance !== void 0 && _window2$performance.timing) {
    return new Date().getTime() - performance.timing.navigationStart;
  } else {
    return new Date().getTime() - initStartTime;
  }
};

var mark = function mark(name) {
  if (typeof name === "undefined") {
    return console.error("Failed to execute 'mark' on 'Performance': 1 argument required, but only 0 present.");
  }

  var entry = {
    name: name + "",
    entryType: "mark",
    startTime: getCurrentTime(),
    duration: 0
  };
  markList.push(entry);
  sendUserTimings(entry);
  return entry;
};

var markWithEntry = function markWithEntry(entry) {
  sendUserTimings(_Object$assign({
    entryType: "mark",
    duration: 0
  }, entry));
  return entry;
};

var measure = function measure(name, startMarkName, endMarkName) {
  if (typeof name === "undefined") {
    return console.error("Failed to execute 'measure' on 'Performance': at least 1 argument required, but only 0 present.");
  }

  var startMark = typeof startMarkName === "undefined" ? null : findMark(startMarkName),
      endMark = typeof endMarkName === "undefined" ? null : findMark(endMarkName); // 当名字传进来了，但是没找到对应的mark点，要抛出错误

  if (typeof startMarkName !== "undefined" && !startMark) {
    return console.error("Failed to execute 'measure' on 'Performance': The mark '".concat(startMarkName, "' does not exist."));
  }

  if (typeof endMarkName !== "undefined" && !endMark) {
    return console.error("Failed to execute 'measure' on 'Performance': The mark '".concat(endMarkName, "' does not exist."));
  }

  startMark = startMark || {
    startTime: 0
  };
  endMark = endMark || {
    startTime: 0
  };
  var entry = {
    name: name + "",
    entryType: "measure",
    startTime: startMark.startTime,
    duration: (endMark.startTime || getCurrentTime()) - startMark.startTime
  };
  sendUserTimings(entry);
  return entry;
};

var measureWithEntry = function measureWithEntry(entry) {
  sendUserTimings(_Object$assign({
    entryType: "measure"
  }, entry));
  return entry;
};

export { mark, markWithEntry, measure, measureWithEntry };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-perf@1.1.7@@ali/aes-tracker-plugin-perf/es/polyfill-usertiming.js
// module id = null
// module chunks = 